import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPhotoNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M9.5 4a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8 7.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" />
        <path d="M1 4a3 3 0 013-3h16a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3zm3-1a1 1 0 00-1 1v10.586L4.586 13a2 2 0 012.828 0L9 14.586 15.586 8a2 2 0 012.828 0L21 10.586V4a1 1 0 00-1-1zM3 20a1 1 0 001 1h16a1 1 0 001-1v-6.586l-4-4-8 8-3-3-3 3z" />
      </g>
    </svg>
  )
);
SvgActionsPhotoNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPhotoNormalSmall;
